<template>
  <div class="text-center">
    <v-badge
      v-if="exists_cart"
      right
      :content="`${product_cart.qty}`"
      color="accent"
      offset-x="30"
      offset-y="30"
    >
      <img
        @click="pushDetail(item.id, item.slug)"
        :input-value="active"
        :src="item.url_image_flask"
        class="flask_image_home"
        alt=""
        loading="lazy"
      >
    </v-badge>
    <img
      v-else
      @click="pushDetail(item.id, item.slug)"
      :input-value="active"
      :src="item.url_image_flask"
      class="flask_image_home"
      :alt="item.name"
      loading="lazy"
    ><br>
    <span class="color-blue font-backward h6 font-weight-bold">{{ item.name }}</span> <br>
    <span class="color-blue font-general-r">
      {{ item.have_variants ? currencyFormat(price) : currencyFormat(item.price) }}
    </span>
    <div class="mt-2 mb-2">
      <v-menu v-if="item.have_variants" offset-y top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            color="accent"
            v-bind="attrs"
            v-on="on"
            class="btn-dropdown-nv"
          >
            {{ product_cart.option_size ? product_cart.option_size : 'Tamaño' }}
            <v-icon color="primary" small>mdi-menu-swap</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in item.variants"
            :key="index"
            @click="selectSize(item)"
          >
            <v-list-item-title>{{ item.attribute.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <div :class="`container-quantity-cart ${item.have_variants ? 'mt-1' : 'mt-12'} m-auto`">
        <div class="buttons-actions-cart">
          <v-icon small @click="resQuantity" color="accent">mdi-minus</v-icon>
          <span class="color-blue font-general-r">{{ product_cart.qty }}</span>
          <v-icon small @click="sumQuantity" color="accent">mdi-plus</v-icon>
        </div>
      </div>
    </div>
    <v-btn
      @click="addToCart()"
      elevation="0"
      color="primary"
      :loading="loading_btn"
      class="nv-btn nv-btn-hover nv-btn-small"
    >AGREGAR</v-btn>

  </div>
</template>

<script>
import CartService from '@/services/cart.service'
import { mapState } from 'vuex'
import { currencyFormat } from '@/helpers'

export default {
  props: ['item', 'active'],
  data() {
    return {
      price: 0,
      exists_cart: false,
      added_cart: false,
      loading_btn: false,
      product_cart: {
        option_size: '',
        qty: 1,
        product: '',
        price: 0.00,
        variant_id: ''
      }
    }
  },
  computed: {
    ...mapState(['cart'])
  },
  methods: {
    pushDetail(id, slug) {
      this.$router.push({
        path: `/helado-sabor/${slug}/${id}`
      })
    },
    async addToCart() {
      try {
        if (this.item.have_variants && !this.product_cart.option_size) {
          return this.$swal('Debes elegir un tamaño para tu helado', '', 'warning')
        } else {
          this.loading_btn = true
          const { data:res } = await CartService.verifiedStock(
            this.item.id,
            this.product_cart.variant_id,
            this.product_cart.qty
          )
          if (!res.success) {
            this.loading_btn = false
            return this.$swal('La cantidad elegida no esta disponible', '', 'warning')
          }
          if (!this.item.have_variants) {
            this.product_cart.price = parseFloat(this.item.price)
          }
          this.product_cart.product = this.item
          this.$store.dispatch('addItemCart', this.product_cart)

          setTimeout(() => {
            this.loading_btn = false
            this.added_cart = true
            this.getAddToCart(this.item.id)
            this.$emit('addCart')
          }, 500)
        }
      } catch (error) {
        console.log(error)
        this.loading_btn = false
        this.$swal('En estos momentos nieve de olla no esta disponible', '', 'warning')
      }
    },
    getAddToCart(product_id) {
      let match = false
      let item = {}
			this.cart.cart_products.forEach(i => {
				if (i.product.id == product_id) {
					match = true
          item = i
				}
      })
      if (match) {
        this.product_cart.qty = parseInt(item.quantity)
        this.product_cart.option_size = item.option_size
        this.product_cart.variant_id = item.variant_id
        this.product_cart.price = item.price
        this.product_cart.product = item.product
        this.exists_cart = true
      }
		},
    selectSize(variant) {
      this.price = variant.price
      this.product_cart.option_size = variant.attribute.name
      this.product_cart.price = variant.price
      this.product_cart.variant_id = variant.id
    },
    sumQuantity() {
      this.product_cart.qty++
    },
    resQuantity() {
      if (this.product_cart.qty > 1) {
        this.product_cart.qty--
      }
    },
    currencyFormat(price) {
			return currencyFormat(price)
		}
  },
  mounted() {
    this.getAddToCart(this.item.id)
  }
}
</script>

<style scoped>
  .btn-dropdown-nv {
    border: 1px solid var(--color-tertiary) !important;
  }
  .container-quantity-cart {
    width: 100px !important;
  }
  >>>.v-badge__badge {
    height: 25px;
    min-width: 25px;
    border-radius: 50%;
    font-size: 15px;
  }
  @media only screen and (min-width: 1720px) and (max-width: 3000px) {
    .container-quantity-cart {
      width: 200px !important;
    }
  }
</style>
